var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExpand = function SvgExpand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M11.35 5.95a.5.5 0 0 1-.5.5H7.156l2.44 2.439 1.292 1.293a.5.5 0 0 1-.707.707L8.889 9.596l-2.44-2.44v3.693a.5.5 0 0 1-1 0v-4.9a.5.5 0 0 1 .5-.5h4.9a.5.5 0 0 1 .5.5Zm1.418 6.818a.5.5 0 0 1 .707 0l1.293 1.293 2.682 2.682v-3.592a.5.5 0 1 1 1 0v4.9a.5.5 0 0 1-.5.5h-4.9a.5.5 0 1 1 0-1h3.794l-2.783-2.783-1.293-1.293a.5.5 0 0 1 0-.707Z",
    clipRule: "evenodd"
  })));
};
export default SvgExpand;